// AUTO-GENERATED by scripts/bump-version.mjs. Do not edit by hand.
// Bumped on every commit by the pre-commit git hook.
export const VERSION = 'NV1.7';
export const SEMVER  = '1.7.0';
